// 前端应用入口：装配全局插件、样式与 PWA 安装监听后挂载 Vue 应用。
import { createApp } from "vue";
import App from "./App.vue";
import setupPlugins from "@/plugins";
import { initializePwaInstall } from "@/composables/usePwaInstall";

// 本地SVG图标
import "virtual:svg-icons-register";

// 样式
import "element-plus/theme-chalk/dark/css-vars.css";
import "@/styles/core/index.scss";
import "uno.css";
import "animate.css";

// 存储请求取消函数的全局数组（与 axios 拦截器中的 window.axiosCancelTokens 配套）
window.axiosCancelTokens = [];

// 在布局加载前捕获 Chrome/Edge 的安装事件，供 Office 顶栏按钮稍后使用。
initializePwaInstall();

const app = createApp(App);
app.use(setupPlugins);
app.mount("#app");
